import apiFaq from '@/api/faq'

const state = {
    data: null,
    isLoading: false,
    error: null
}

export const mutationTypes = {
    getFaqsStart: '[faqs] Get faqs start',
    getFaqsSuccess: '[faqs] Get faqs success',
    getFaqsFailure: '[faqs] Get faqs failure'
}

export const actionTypes = {
    getFaqs: '[faqs] Get faqs'
}

const mutations = {
    [mutationTypes.getFaqsStart](state) {
        state.isLoading = true
        state.data = null
    },

    [mutationTypes.getFaqsSuccess](state, payload) {
        state.data = payload
        state.isLoading = false
    },

    [mutationTypes.getFaqsFailure](state) {
        state.isLoading = false
    }
}

const actions = {
    [actionTypes.getFaqs](context) {
        context.commit(mutationTypes.getFaqsStart)
        return new Promise(resolve => {
            apiFaq
                .getFaqs()
                .then(response => {
                    context.commit(mutationTypes.getFaqsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(() => {
                    context.commit(mutationTypes.getFaqsFailure)
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
